import { useEffect, useState } from 'react';
import { DOCX_MIME_TYPE } from './document-viewer/document-viewer-registry';
import { DocxPreviewRenderer } from './DocxPreviewRenderer';

type CodegenDocxPanelPreviewProps = {
  filename: string;
  sourceUrl: string;
};

export function CodegenDocxPanelPreview({ filename, sourceUrl }: CodegenDocxPanelPreviewProps) {
  const [blob, setBlob] = useState<Blob | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<'generating' | 'ready' | 'error'>('generating');
  const [retryToken, setRetryToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setStatus('generating');
    setError(null);
    setBlob(null);

    (async () => {
      try {
        const response = await fetch(sourceUrl);
        if (!response.ok) {
          throw new Error('preview_fetch_failed');
        }
        const nextBlob = await response.blob();
        if (cancelled) {
          return;
        }
        setBlob(nextBlob.type ? nextBlob : new Blob([nextBlob], { type: DOCX_MIME_TYPE }));
        setStatus('ready');
      } catch {
        if (!cancelled) {
          setStatus('error');
          setError(`Impossible de charger l’aperçu de ${filename}.`);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [filename, retryToken, sourceUrl]);

  return (
    <DocxPreviewRenderer
      blob={blob}
      error={error}
      onRetry={() => setRetryToken((value) => value + 1)}
      status={status}
    />
  );
}
